import React, { Component } from 'react';
import { Button } from 'grommet/components/Button';

export default class ButtonBlue extends Component {
    constructor(props) {
        super(props);
        this.buttonName = props.buttonName;
        this.class = props.class;
        this.action = props.action;
        this.type = props.type;
    }
    static props = {
        buttonName: '',
        class: '',
        type: null

    }
    render() {
        return (
            <Button hoverIndicator={false} focusIndicator={false} label={this.props.buttonName} onClick={this.props.onClick} type={this.props.type} className={` button-style   ${this.props.class}`} disabled={this.props.disable===undefined? false:this.props.disable } />
        )
    }
}
